"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JWT_SET = void 0;
exports.default = reducer;
exports.doSessionPing = exports.doJwtRefresh = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _fetchRetry = _interopRequireDefault(require("../util/fetch-retry"));
var _logger = _interopRequireDefault(require("../util/logger"));
var _reduxActions = require("redux-actions");
var _config = _interopRequireDefault(require("../config"));
var _logoutUser = _interopRequireDefault(require("../util/logoutUser"));
var _setJwtAndSessApiCookies = _interopRequireDefault(require("../util/setJwtAndSessApiCookies"));
var _signInErrorCodes = require("../util/signInErrorCodes");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line no-unused-vars
var regeneratorRuntime = require('regenerator-runtime');
var JWT_SET = exports.JWT_SET = '@@nui-auth/JWT_SET';
var doSessionPing = exports.doSessionPing = function doSessionPing(cb) {
  var host = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var resText, res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            resText = '';
            res = {};
            _context.prev = 2;
            _context.next = 5;
            return (0, _fetchRetry.default)("".concat(host).concat(_config.default.nui.baseUrl, "/nui-auth/api/session?touchOnly=true"), {
              credentials: 'same-origin'
            });
          case 5:
            res = _context.sent;
            _context.next = 8;
            return res.text();
          case 8:
            resText = _context.sent;
            if (!(res.status === 200)) {
              _context.next = 13;
              break;
            }
            if (cb) {
              cb();
            }
            _context.next = 14;
            break;
          case 13:
            throw resText;
          case 14:
            _context.next = 20;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](2);
            _logger.default.error({
              err: _context.t0,
              res: res,
              description: resText,
              category: 'nui-auth-client',
              subcategory: 'session-ping-failure'
            });
            if (cb) {
              cb();
            }
          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 16]]);
  }));
};
var doJwtRefresh = exports.doJwtRefresh = function doJwtRefresh() {
  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var _getState, _getState$JWT, _getState$JWT$failedR, failedRefreshAttempts, resText, resData, res, updatedJWT;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _getState = getState(), _getState$JWT = _getState.JWT;
              _getState$JWT = _getState$JWT === void 0 ? {} : _getState$JWT;
              _getState$JWT$failedR = _getState$JWT.failedRefreshAttempts, failedRefreshAttempts = _getState$JWT$failedR === void 0 ? 0 : _getState$JWT$failedR;
              resText = '';
              resData = {};
              res = {};
              _context2.prev = 6;
              _context2.next = 9;
              return (0, _fetchRetry.default)("".concat(host).concat(_config.default.nui.jwt.refresh.url), {
                credentials: 'same-origin'
              });
            case 9:
              res = _context2.sent;
              _context2.next = 12;
              return res.text();
            case 12:
              resText = _context2.sent;
              if (!(res.status === 200)) {
                _context2.next = 21;
                break;
              }
              resData = JSON.parse(resText);
              resData.failedRefreshAttempts = 0;

              // set new JWT api cookies
              if (!resData.doApiCookies) {
                _context2.next = 19;
                break;
              }
              _context2.next = 19;
              return (0, _setJwtAndSessApiCookies.default)(resData.JWT, resData.sessionId, resData.apigwUrl, resData.apigwBrowserUrl);
            case 19:
              dispatch((0, _reduxActions.createAction)(JWT_SET, null, function () {
                return {
                  analytics: false
                };
              })(resData));
              return _context2.abrupt("return");
            case 21:
              throw resText;
            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](6);
              if (!(resText && resText.indexOf('"code": 60') !== -1)) {
                _context2.next = 30;
                break;
              }
              _logger.default.error({
                err: _context2.t0,
                res: res,
                description: resText,
                category: 'nui-auth-client',
                subcategory: 'jwt-refresh-failure-60'
              });
              dispatch((0, _logoutUser.default)('error'));
              return _context2.abrupt("return");
            case 30:
              if (!(failedRefreshAttempts > 3)) {
                _context2.next = 34;
                break;
              }
              _logger.default.error({
                err: _context2.t0,
                res: res,
                description: resText,
                category: 'nui-auth-client',
                subcategory: 'jwt-refresh-failure-attempts'
              });
              dispatch((0, _logoutUser.default)('error'));
              return _context2.abrupt("return");
            case 34:
              //force to re-ping jwtRefresh
              updatedJWT = {}; // retry in 10 sec
              updatedJWT.JWTExpiresTS = Math.floor(Date.now() / 1000) + 30;
              updatedJWT.failedRefreshAttempts = failedRefreshAttempts + 1;
              _logger.default.error({
                err: _context2.t0,
                res: res,
                description: resText,
                category: 'nui-auth-client',
                subcategory: 'jwt-refresh-failure'
              });
              dispatch((0, _reduxActions.createAction)(JWT_SET, null, function () {
                return {
                  analytics: false
                };
              })(updatedJWT));
            case 39:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 24]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case JWT_SET:
      return _objectSpread(_objectSpread({}, state), action.payload || {});
    case _signInErrorCodes.USER_LOGOUT:
      return null;
    default:
      return state;
  }
}